/// <amd-module name="SuiteCommerce.StockNotifications.Item.ImageHelper"/>
define("SuiteCommerce.StockNotifications.Item.ImageHelper", ["require", "exports", "underscore", "SuiteCommerce.StockNotifications.Utils", "SuiteCommerce.StockNotifications.Configuration"], function (require, exports, _, Utils_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemImageHelper = /** @class */ (function () {
        function ItemImageHelper() {
        }
        ItemImageHelper.findThumbnail = function (itemImagesDetail) {
            var thumbnail = _(itemImagesDetail).find(function (image) {
                return image.thumbnail;
            });
            return thumbnail;
        };
        ItemImageHelper.getThumbnailExisting = function (itemImagesDetail) {
            if (!itemImagesDetail.thumbnail) {
                itemImagesDetail = this.findThumbnail(itemImagesDetail);
            }
            if (_.isArray(itemImagesDetail.thumbnail.urls) && itemImagesDetail.thumbnail.urls.length) {
                return itemImagesDetail.thumbnail.urls[0];
            }
            return itemImagesDetail.thumbnail;
        };
        ItemImageHelper.getThumbnailFromAll = function (itemModel, itemImagesDetailArg) {
            var flattenedImages;
            var itemImagesDetail = itemImagesDetailArg;
            itemImagesDetail = itemImagesDetail.media || itemImagesDetail;
            if (!itemModel.isMatrixParent) {
                itemImagesDetail = this.filterImagesBySelectedOption(itemModel, itemImagesDetail);
            }
            flattenedImages = Utils_1.Utils.imageFlatten(itemImagesDetail);
            if (flattenedImages.length) {
                return flattenedImages[0];
            }
            return null;
        };
        ItemImageHelper.filterImagesBySelectedOption = function (itemModel, itemImagesDetail) {
            var filterImageOptionIds = Configuration_1.Configuration.get('productline.multiImageOption') || [];
            var itemOptions = itemModel.itemOptions;
            var filteredImages = itemImagesDetail;
            if (itemOptions) {
                filterImageOptionIds.forEach(function (itemIoptionId) {
                    var itemOptionToFilter = itemOptions.findWhere({ cartOptionId: itemIoptionId });
                    var filterValue;
                    var label;
                    // if the option/dimension has a value set
                    if (itemOptionToFilter) {
                        filterValue = itemModel.get(itemOptionToFilter.itemOptionId);
                        if (filterValue) {
                            label = filterValue.toLowerCase();
                            _(filteredImages).each(function (value, key) {
                                if (key.toLowerCase() === label) {
                                    filteredImages = value;
                                }
                            });
                        }
                    }
                });
            }
            return filteredImages;
        };
        return ItemImageHelper;
    }());
    exports.ItemImageHelper = ItemImageHelper;
});
